// ----------------------------------------------------------------------
import { MenuPopoverArrowValue } from './types';

type GetPositionReturn = {
  arrow: MenuPopoverArrowValue;
  style?: Record<string, number>;
  anchorOrigin: { vertical: string; horizontal: string };
  transformOrigin: { vertical: string; horizontal: string };
};

export default function getPosition(
  arrow: MenuPopoverArrowValue,
  anchorEl?: HTMLElement | null
): GetPositionReturn {
  if (!anchorEl) {
    return getDefaultPosition(arrow);
  }

  const rect = anchorEl.getBoundingClientRect();
  const { innerHeight } = window;

  const anchorOrigin = { vertical: 'bottom', horizontal: 'left' };
  const transformOrigin = { vertical: 'top', horizontal: 'left' };
  const style = {};

  // Handle centering it vertically
  if (rect.top + rect.height / 2 < innerHeight / 2) {
    anchorOrigin.vertical = 'bottom';
    transformOrigin.vertical = 'top';
  } else {
    anchorOrigin.vertical = 'top';
    transformOrigin.vertical = 'bottom';
  }

  const finalArrow = (transformOrigin.vertical +
    '-' +
    transformOrigin.horizontal) as MenuPopoverArrowValue;
  return { arrow: finalArrow, style, anchorOrigin, transformOrigin };
}

function getDefaultPosition(arrow: MenuPopoverArrowValue): GetPositionReturn {
  let props;

  switch (arrow) {
    case 'top-left':
      props = {
        style: { ml: -0.75 },
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
      };
      break;
    case 'top-center':
      props = {
        style: {},
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        transformOrigin: { vertical: 'top', horizontal: 'center' },
      };
      break;
    case 'top-right':
      props = {
        style: { ml: 0.75 },
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'right' },
      };
      break;
    case 'bottom-left':
      props = {
        style: { ml: -0.75 },
        anchorOrigin: { vertical: 'top', horizontal: 'left' },
        transformOrigin: { vertical: 'bottom', horizontal: 'left' },
      };
      break;
    case 'bottom-center':
      props = {
        style: {},
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        transformOrigin: { vertical: 'bottom', horizontal: 'center' },
      };
      break;
    case 'bottom-right':
      props = {
        style: { ml: 0.75 },
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        transformOrigin: { vertical: 'bottom', horizontal: 'right' },
      };
      break;
    case 'left-top':
      props = {
        style: { mt: -0.75 },
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
      };
      break;
    case 'left-center':
      props = {
        style: {},
        anchorOrigin: { vertical: 'center', horizontal: 'right' },
        transformOrigin: { vertical: 'center', horizontal: 'left' },
      };
      break;
    case 'left-bottom':
      props = {
        style: { mt: 0.75 },
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transformOrigin: { vertical: 'bottom', horizontal: 'left' },
      };
      break;
    case 'right-top':
      props = {
        style: { mt: -0.75 },
        anchorOrigin: { vertical: 'top', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'right' },
      };
      break;
    case 'right-center':
      props = {
        style: {},
        anchorOrigin: { vertical: 'center', horizontal: 'left' },
        transformOrigin: { vertical: 'center', horizontal: 'right' },
      };
      break;
    case 'right-bottom':
      props = {
        style: { mt: 0.75 },
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'bottom', horizontal: 'right' },
      };
      break;

    // top-right
    default:
      props = {
        style: { ml: 0.75 },
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'right' },
      };
  }

  return { arrow: arrow, ...props };
}
